import { render, staticRenderFns } from "./W0104V0001.vue?vue&type=template&id=2f6548d8&scoped=true&"
import script from "./W0104V0001.vue?vue&type=script&lang=js&"
export * from "./W0104V0001.vue?vue&type=script&lang=js&"
import style0 from "./W0104V0001.vue?vue&type=style&index=0&id=2f6548d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6548d8",
  null
  
)

export default component.exports